import { PhoneNumberAPI } from '@philips-emr/tws-components';
import { Country } from '@philips-emr/tws-constants';
import Controller, { OnBeforeSubmit, OnMount } from '@philips-emr/tws-core/lib/client';
import { AbortableSubmitEvent, MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService } from '@philips-emr/tws-core/lib/services';

import { FragmentNames, SolicitarParticipacaoAliases } from '../../codegen';
import { Endpoints } from '../../definitions/endpoints';
import { ToastService } from '../../services';
import BaseController from '../base/base-controller';

@Controller({ fragment: FragmentNames.SOLICITAR_PARTICIPACAO })
export default class SolicitarParticipacaoController extends BaseController {

  @OnBeforeSubmit(SolicitarParticipacaoAliases.FORM)
  onBeforeSubmit({ abort, record }: AbortableSubmitEvent): void {
    const { nrSeqBeneficiario } = this.context.getBulkData();

    const isSubmittable: Promise<boolean> = HttpService.post<{}>(Endpoints.POST.SOLICITAR_PARTICIPACAO, { nrSeqBeneficiario }, { body: record })
      .then(response => {
        ToastService.open(response);
        return false;
      })
      .catch(response => {
        ToastService.open(response);
        return true;
      });

    abort(isSubmittable);
  }

  @OnMount(SolicitarParticipacaoAliases.PHONE_NUMBER)
  onMountPhone(event : MountEvent): void {
    const api = event.target as PhoneNumberAPI;
    api.setCountry(Country.BR);
  }
}
